import { render, staticRenderFns } from "./Paoyingchup.vue?vue&type=template&id=3b98790a&scoped=true&"
import script from "./Paoyingchup.vue?vue&type=script&lang=js&"
export * from "./Paoyingchup.vue?vue&type=script&lang=js&"
import style0 from "./Paoyingchup.vue?vue&type=style&index=0&id=3b98790a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98790a",
  null
  
)

export default component.exports